import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { Button as AntButton, Card, Dropdown, MenuProps, Modal, Spin } from 'antd';
import { ReactComponent as Ellipsis } from '../../../assets/ellipsis.svg';
import { getInstitutionByShortName } from '../../../requests';
import { INSTITUTION_NAME } from '../../../utils/constants';

import EditInstitution from './editInstitution';

const Institution = () => {
  const [openEdit, setOpenEdit] = useState(false);

  const handleEdit = () => setOpenEdit(true);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['get-institution'],
    queryFn: () => getInstitutionByShortName(INSTITUTION_NAME),
  });

  const school = data?.data as Institution;

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Edit',
      onClick: () => handleEdit(),
    },
  ];

  if (isLoading) {
    return <Spin />;
  }

  if (isError) {
    return <div>Error: {error?.message}</div>;
  }

  return (
    <div>
      <h3>Institution</h3>

      <br />

      <Card bordered={false} style={{ maxWidth: '34.286rem' }}>
        <Dropdown menu={{ items }} trigger={['click']}>
          <AntButton style={{ display: 'block', marginLeft: 'auto' }} icon={<Ellipsis />} />
        </Dropdown>

        <section className="fields">
          <div className="space-between-grid">
            <b>Institution Name</b>
            <p>{school?.institutionName}</p>
          </div>
          <div className="space-between-grid">
            <b>Short Name</b>
            <p>{school?.institutionShortName}</p>
          </div>
          <div className="space-between-grid">
            <b>Country</b>
            <p>{school?.countryId}</p>
          </div>
          <div className="space-between-grid">
            <b>State</b>
            <p>{school?.stateId}</p>
          </div>
          <div className="space-between-grid">
            <b>Address</b>
            <p>{school?.address}</p>
          </div>
        </section>
      </Card>

      <Modal
        open={openEdit}
        onCancel={() => setOpenEdit(false)}
        centered
        title="Edit Institution Details"
        footer={null}
      >
        <EditInstitution
          record={school}
          handleClose={() => {
            setOpenEdit(false);
            refetch();
          }}
        />
      </Modal>
    </div>
  );
};

export default Institution;
